/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require("trix")
require("@rails/actiontext")

console.log('Hello World from Bochen');
import 'fontawesome-4.7';
import '../stylesheets/application.scss';
import Rails from '@rails/ujs';
import './bootstrap_sb_admin_base_v2';

import acceptTerms from './eventListeners/acceptTerms';
import adminMessage from './eventListeners/adminMessage';
import changingCookiesAndLocale from './eventListeners/cookies';
import setupDateTimePicker from './eventListeners/dateTimePicker';
import discountEvents from './eventListeners/discountEvents';
import trixEditor from './eventListeners/trixEditor';
import manualReassigning from './eventListeners/manualReassigning';
import payment from './eventListeners/payment';		
import user from './eventListeners/user';			
import workshop from './eventListeners/workshop';	
import workshopCategory from './eventListeners/workshopCategory';	

trixEditor();	

document.addEventListener('DOMContentLoaded', acceptTerms);
document.addEventListener('DOMContentLoaded', adminMessage);	
document.addEventListener('DOMContentLoaded', changingCookiesAndLocale);
document.addEventListener('DOMContentLoaded', setupDateTimePicker);
document.addEventListener('DOMContentLoaded', discountEvents);
document.addEventListener('DOMContentLoaded', manualReassigning);
document.addEventListener('DOMContentLoaded', payment);
document.addEventListener('DOMContentLoaded', user);
document.addEventListener('DOMContentLoaded', workshop);
document.addEventListener('DOMContentLoaded', workshopCategory);

const images = require.context('../images/', true)
const imagePath = (name) => images(name, true)


Rails.start();
